module.exports = __webpack_public_path__ + "img/1.9472be51.png";